import axios from "axios";
const queryString = require('query-string');
export default {
    getAllPolicies(requestParam) {
        let queryParams = queryString.stringify(requestParam);
        return axios({
            method: "GET",
            url: `/api/cashback-policy/get-policies?${queryParams}`,
            withCredentials: true,
        });
    },
    upsertPolicy(payload) {
        return axios({
            method: "POST",
            url: `/api/cashback-policy/upsert`,
            data: payload,
            withCredentials: true,
        });
    },
    deletePolicy(id) {
        return axios({
            method: "DELETE",
            url: `/api/cashback-policy/${id}`,
            withCredentials: true,
        });
    },
    detailPolicy(id) {
        return axios({
            method: "GET",
            url: `/api/cashback-policy/${id}`,
            withCredentials: true,
        });
    },
    changeStatus(payload) {
        return axios({
            method: "POST",
            url: `/api/cashback-policy/status`,
            data: payload,
            withCredentials: true,
        });
    },
};
